import styled from 'styled-components';
import { P } from '@workramp/ui';

export const StyledErrorMessage = styled(P)`
  color: ${({ theme }) => theme.colors.on[600]};
`;

export const StyledCTAText = styled.a`
  color: ${({ theme }) => theme.colors.primary[600]};
`;

export const ErrorPageWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing(6)}px;
  padding-bottom: ${({ theme }) => theme.spacing(24)}px;
  background-color: ${({ theme }) => theme.colors.on[0]};
`;
